import "../scss/style.scss";

import "./template-pages/single-global.js";
